import { AwaitResponse } from '@/utils/MockUtils';

export default class PremiumImpactServices {
  /**
   * Retrieves the premium adjustment prices and dates for the Premium Adjustment timeline
   * @param {string} memberNumber member number or policy number
   * @param {boolean} showPremiumPaymentAmount whether the premium payment amount is to be included in response
   * @param {string} currentDate current date in 'YYYY-MM-DD'
   * @returns
   */
  static getPremiumAdjustmentPrices() {
    const premiumAdjustmentData = {
      '@odata.context': 'https://dhl-delta-dev.crm6.dynamics.com/api/data/v9.1/$metadata#Microsoft.Dynamics.CRM.dhl_PremiumAdjustmentsResponse',
      errorMessage: null,
      responseString:
        '{\r\n  "prorataPrice": 121.36,\r\n  "policyCrn": "13902235",\r\n  "nextContributionDate": "2022-09-02",\r\n  "futureContributionDate": "2022-09-16",\r\n  "frequency": "fortnightly"\r\n}',
    };

    return AwaitResponse(JSON.parse(premiumAdjustmentData.responseString));
  }
}
